import api from "../API/api";
import { Capacitor } from '@capacitor/core';

export const authLogin = (body, token) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithCaptch(`authapi/auths/login`, body, token)
        .then(async (res) => {  // <-- Added async here to allow await usage
          // After successful login, store token for push notifications
          if (res && res.data && res.data.jwtToken) {
            try {
              // For native API call authorization with FCM
              if (window.Capacitor && window.Capacitor.isNativePlatform()) {
                console.log("★★★★★ STORING AUTH TOKEN FOR NATIVE FCM SERVICE ★★★★★");
                
                // Save to localStorage
                localStorage.setItem('token', res.data.jwtToken);
                
                // Save token in ALL possible places for native code to find
                
                // 1. Try via the FCMBridge plugin if available
                if (window.Capacitor.isPluginAvailable('FCMBridge')) {
                  console.log("★★★★★ Using FCMBridge plugin to save token ★★★★★");
                  window.Capacitor.Plugins.FCMBridge.saveAuthToken({
                    authToken: res.data.jwtToken
                  }).catch(e => console.log("Error saving auth token via plugin", e));
                }
                
                // 2. Try with Storage API
                try {
                  window.Capacitor.Plugins.Storage.set({
                    key: "AuthToken",
                    value: res.data.jwtToken
                  });
                  console.log("★★★★★ Saved token with Storage plugin ★★★★★");
                } catch (e) {
                  console.log("Error saving with Storage plugin", e);
                }
                
                // 3. Use Preferences API to store token in CapacitorStorage which native code can read
                try {
                  // Save to Capacitor Storage - this is the key method that will work!
                  console.log("★★★★★ Saving token to CapacitorStorage via Preferences ★★★★★");
                  await window.Capacitor.Plugins.Preferences.set({
                    key: "AuthToken",
                    value: res.data.jwtToken
                  });
                  console.log("★★★★★ Successfully saved token with Preferences plugin ★★★★★");
                  
                  // Also save to "token" key to be doubly sure
                  await window.Capacitor.Plugins.Preferences.set({
                    key: "token",
                    value: res.data.jwtToken
                  });
                  
                  // For debugging: verify token was saved
                  const savedToken = await window.Capacitor.Plugins.Preferences.get({ key: "AuthToken" });
                  console.log("★★★★★ Verified saved token:", savedToken.value ? "SUCCESS" : "FAILED", "★★★★★");
                  
                  // Extra token save for debugging
                  await window.Capacitor.Plugins.Preferences.set({
                    key: "DebugToken",
                    value: res.data.jwtToken
                  });
                } catch (e) {
                  console.log("Error saving with Preferences", e);
                }
              }
            } catch (e) {
              console.log("Error saving auth token for FCM", e);
            }
          }
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};

export const getReferralCode = (code) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .get(`authapi/auths/refcode/${code}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const createConsult = (body, token) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithCaptch(`authapi/auths/create-provider`, body, token)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("errerr", err);
          reject(err);
        });
    });
  };
};

export const createUser = (body, token) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithCaptch(`authapi/auths/create-user`, body, token)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const userImageUpload = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`userapi/users/${id}/upload-images`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const uploadImage64Base = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`userapi/users/${id}/upload-images/base64`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const uploadImage64BaseSPIdCard = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`authapi/auths/accounts/${id}/idcard-images/base64`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const uploadImage64BaseSP = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`authapi/auths/accounts/${id}/images/base64`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};
export const uploadImage64BaseAccount = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(
          `userapi/users/accounts/${id}/register/upload-images/base64`,
          body
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const editProfile = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .patchtwithToken(`userapi/users/${id}`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const addMultiUserData = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithToken(`userapi/users/accounts/${id}/profiles`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const getProfileData = (id) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .getwithToken(`userapi/users/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const forgotPasswords = (body, token) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithCaptch(`authapi/auths/forgot-password`, body, token)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};

export const resetPassword = (body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .put(`authapi/auths/forgot-password-confirm`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};

export const chnagePassword = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`authapi/auths/${id}/reset-password`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};

export const refreshToken = (id) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .put(`authapi/auths/${id}/refresh-token`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};

export const logoutuser = () => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Get FCM token and device ID for the logout payload
        let fcmToken = localStorage.getItem('fcm_token');
        let deviceId = 'unknown-device';
        
        // Try to get device ID if on a native platform
        if (Capacitor.isNativePlatform()) {
          try {
            // Import Device only if we're on a native platform
            const { Device } = await import('@capacitor/device');
            const deviceInfo = await Device.getId();
            deviceId = deviceInfo.identifier;
            console.log('📱 Device ID for logout:', deviceId);
          } catch (deviceError) {
            console.error('❌ Error getting device ID for logout:', deviceError);
            // Use fallback ID
            deviceId = 'fallback-' + Math.random().toString(36).substring(2, 10);
          }
        }
        
        // Payload for logout request
        const logoutPayload = {
          deviceId: deviceId,
          fcmToken: fcmToken || ''
        };
        
        console.log('🔄 SENDING LOGOUT REQUEST WITH PAYLOAD:', logoutPayload);
        
        // Make the API call with the token and device info
        return api
          .postwithToken(`authapi/auths/logout`, logoutPayload)
          .then((res) => {
            console.log('✅ LOGOUT API CALL SUCCESSFUL:', res?.status);
            resolve(res);
          })
          .catch((err) => {
            console.error('❌ LOGOUT API CALL FAILED:', err);
            reject(err);
          });
      } catch (error) {
        console.error('❌ ERROR PREPARING LOGOUT REQUEST:', error);
        reject(error);
      }
    });
  };
};

export const uploadImageAddProfile = (data) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`userapi/users/upload-images/base64`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};
export const createmultipleAccounts = (data) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithToken(`userapi/users/profiles`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log("error", err);
          reject(err);
        });
    });
  };
};

export const getAccountsData = () => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .getwithToken(`authapi/auths/accounts`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const deleteProfile = (id) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .deleteWithToken(`userapi/users/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const updateAccountData = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithToken(`authapi/auths/accounts/${id}`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const editUserProfile = (id, body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .patchtwithToken(`authapi/auths/accounts/${id}`, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const affiliatesVisits = (refCode, token) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .postwithCaptch(`paymentapi/affiliates/${refCode}/visits`, {}, token)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
};

export const sendOtp = (body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .post('authapi/auths/otp/send', body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        }); 
    });
  }
}

export const verifyOtp = (body) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .post('authapi/auths/otp/verify', body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        }); 
    });
  }
}

export const resendEmailVerify = (body, token) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      return api
        .putwithCaptch(
          `authapi/accounts/verify-email/resend/${body}`,"",token
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        }); 
    });
  }
}